<template>
  <div>
    <el-dialog
      title="报价详情"
      :visible="visible"
      width="1200px"
      top="60px"
      center
      :show-close="false"
      @close="close">
      <div slot="title" class="coast-header">
        <h3>{{title}}</h3>
        <img style="width: 30px; height: 30px" :src="ossPath + '/pages/inquiryHall/ico-close-gray.png'" alt="" @click="close">
      </div>
      <div style="height: calc(100vh - 60px); overflow: auto">
        <div class="coast-box" style="display: flex; padding-top: 20px; color: #141414">
          <div style="margin-right: 68px">
            <label style="color: #666666">目的国:</label>
            <span>{{dataInfo.podCountryName || '/'}}</span>
          </div>
          <div style="margin-right: 120px">
            <label style="color: #666666">海外仓:</label>
            <span>{{dataInfo.overseasWarehouseAliasName || '/'}}</span>
          </div>
          <div>
            <label style="color: #666666">目的港:</label>
            <span>{{dataInfo.podPortName || '/'}}</span>
          </div>
        </div>
        <div class="coast-box" v-for="coastBase in dataInfo.quotationList" :key="coastBase.type">
          <template v-if="coastBase.type !== 4">
            <!-- <div class="coast-bar">
              <div class="title">
                {{feetypeOb[coastBase.type]}}
              </div>
            </div> -->
            <div v-for="quotationItem in coastBase.otherPartitionList" :key="quotationItem.feeType">
              <div class="coast-bar">
                <div class="title" v-if="quotationItem.feeType === 1">
                  <div class="title-text">
                    {{feetypeOb[coastBase.type]}}基础费用
                  </div>
                  <div>
                    <span>报价有效时间：{{coastBase.effectiveStartTime || ''}}-{{coastBase.effectiveEndTime || ''}}</span>
                    <span style="margin-left: 40px">参考时效：{{coastBase.aging || '/'}}</span>
                  </div>
                </div>
                <div class="title" v-else-if="quotationItem.feeType === 2">
                  <div class="title-text">
                    {{feetypeOb[coastBase.type]}}额外费
                    <span style="font-weight: 400; font-size: 18px">(可能产生的相关费用)</span>
                  </div>
                </div>
                <div class="title" v-else>
                  <div class="title-text">
                    {{feetypeOb[coastBase.type]}}
                  </div>
                </div>
              </div>
              <coast-table-normal :tableData="quotationItem.priceDetailList" :columnData="coastBase.type === 5 ? gPlusColumns : gColumns" />
            </div>
          </template>
          <template v-else>
            <div class="coast-bar">
              <div class="title">
                <div class="title-text">
                  派送费
                </div>
              </div>
            </div>
            <div style="margin-top: 10px">
              <el-radio-group v-model="currentType" size="small" @change="showFade = true">
                <el-radio-button v-for="deliveryItem in coastBase.deliveryList" :key="deliveryItem.deliveryType" :label="deliveryItem.deliveryType">{{setName(deliveryItem.deliveryType)}}</el-radio-button>
              </el-radio-group>
              <div v-for="deliveryItem in coastBase.deliveryList" :key="deliveryItem.deliveryType" >
                <template v-if="deliveryItem.deliveryType === currentType">
                  <div v-for="deliveryPartitionItem in deliveryItem.deliveryPartitionList" :key="deliveryPartitionItem.id">
                    <template v-if="currentType !== 'ZT'">
                      <p style="margin: 10px 0 0; font-size: 16px; font-weight: bold; line-height: 22px;">派送基本信息</p>
                      <div>
                        <span>报价类型: {{{1: 'FBA', 2: '私人地址'}[deliveryPartitionItem.priceType] || '/'}}</span>
                        <template v-if="deliveryPartitionItem.billingUnit === 'KG'">
                          <span style="margin-left: 80px">体积重比率: {{ deliveryPartitionItem.volumeWeightRatio || '/' }}</span>
                          <el-tooltip class="item" effect="light" placement="top-start" :visible-arrow="false">
                            <div slot="content" style="max-width: 220px">
                              <span>体积重比率用于计算体积重，体积重=长*宽*高/体积重比率</span><br />
                              <span>例如:100CM*100CM*100CM规格的箱子，若体积重比率=6000，则体积重=100*100*100/6000≈167KG</span>
                            </div>
                            <i  style="color:#CCCCCC;vertical-align: middle;margin-bottom: 4px;font-size:16px" class="el-icon-question"></i>
                          </el-tooltip>
                        </template>
                        <span v-if="deliveryPartitionItem.billingUnit === 'CBM'" style="margin-left: 80px">重量转换: {{ deliveryPartitionItem.weightVolumeRatio ? `1CBM = ${deliveryPartitionItem.weightVolumeRatio}KG` : '/' }}</span>
                        <span style="margin-left: 80px">计费单位: {{deliveryPartitionItem.billingUnit || '/'}}</span>
                        <span style="margin-left: 90px">报价有效时间: {{deliveryPartitionItem.effectiveStartTime || ''}} - {{deliveryPartitionItem.effectiveEndTime || ''}}</span>
                        <span style="margin-left: 80px;" v-if="deliveryPartitionItem.billingUnit === 'PLTS'">
                          卡板规格：{{ deliveryPartitionItem.linkLength }}M*{{ deliveryPartitionItem.linkWidth }}M*{{ deliveryPartitionItem.linkHeight }}M
                        </span>
                      </div>
                    </template>
                    <coast-table-normal :tableData="deliveryItem.deliveryType === 'ZT' ? deliveryPartitionItem.ztPriceDetailList : deliveryPartitionItem.quotedPricePartitionList" :columnData="deliveryItem.deliveryType === 'ZT' ? gPlusColumns : deliveryPartitionItem.columns">
                      <el-table-column align="center" class-name="set-bg" prop="partitionName" width="120px" v-if="deliveryItem.deliveryType !== 'ZT'" :label="deliveryPartitionItem.partitionType === 1 ? '派送公里数' : '分区信息'" :formatter="(row) => row[col.prop] || '/'">
                        <template slot-scope="scope">
                          <template v-if="deliveryPartitionItem.partitionType !== 1">
                            <p>{{scope.row.partitionName}}</p>
                            <p>
                              (<tooltipRow1 style="display: inline-block; max-width: calc(100% - 12px); vertical-align: text-top" :contentInfo="setContent(scope.row.partitionInformationList)" />)
                            </p>
                          </template>
                          <p v-else>
                            <template>
                              {{scope.row.segmentStart || '0'}}
                              {{scope.row.segmentEnd ? `-${scope.row.segmentEnd}MILE` : 'MILE+'}}
                            </template>
                          </p>
                        </template>
                      </el-table-column>
                    </coast-table-normal>
                  </div>
                </template>
              </div>
            </div>
          </template>
        </div>
      </div>
      <div slot="footer">
        <el-button type="primary" style="width: 450px; height: 60px; border-radius: 6px; font-size: 20px;" @click="tekeOrder">去下单</el-button>
      </div>
    </el-dialog>
    
  </div>
</template>

<script>
import coastTableNormal from './coast-table-normal.vue'
import tooltipRow1 from '@/components/placeOrder/components/tooltipRow1.vue'
export default {
  components: {
    coastTableNormal,
    tooltipRow1
  },
  props: {
    visible: false,
    title: {
      type: String,
      default: '价格详情'
    },
    dataInfo: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {
      gColumns: [
        { prop: 'feeItemName', label: '费用名称' },
        { prop: 'cntypeCode', label: '柜型', width: '220px' },
        { prop: 'billingUnit', label: '计费单位' },
        { prop: 'price', label: '单价' },
        { prop: 'currency', label: '币种' },
        { prop: 'remark', label: '备注' }
      ],
      gPlusColumns: [
        { prop: 'feeItemName', label: '费用名称' },
        { prop: 'billingUnit', label: '计费单位' },
        { prop: 'price', label: '单价' },
        { prop: 'currency', label: '币种' },
        { prop: 'remark', label: '备注' }
      ],
      delOriColumns: [
        { prop: 'partitionName', label: '目的国分区' },
      ],
      feetypeOb: {
        1: '清关', 2: '提柜', 3: '拆柜', 4: '派送', 5: '增值服务费'
      },
      currentType: null
    }
  },
  computed: {
    currentDelTypeCol() {
      return this.delOriColumns
    }
  },
  watch: {
    visible(val) {
      if (val && this.dataInfo && this.dataInfo.id) this.resetData() 
    },
    dataInfo(val) {
      if (val) {
        if (!this.dataInfo.quotationList) return false
        const delOb = this.dataInfo.quotationList ? this.dataInfo.quotationList.find(v => v.type === 4) : null
        // this.currentType = delOb.deliveryPartitionList[0].deliveryType
        this.currentType = delOb.deliveryList && delOb.deliveryList.length ? delOb.deliveryList[0].deliveryType : ''
        this.resetData()
      }
    }
  },
  methods: {
    tekeOrder() {
      if (location.host === 'oms.dev.huodaipin.com.cn') {
        // qa2
        window.open('http://support.dev.huodaipin.com.cn/')
      }else if(location.host === "uat.huodaipin.com.cn"){
        // uat
        window.open('http://support.uat.huodaipin.com.cn/')
      }else if(location.host === "www.huodaipin.com" || location.host === "huodaipin.com"){
        // 生产
        window.open('https://support.huodaipin.com/')
      } else {
        window.open('http://support.dev.huodaipin.com.cn/')
      }
    },
    resetData() {
      const delOb = this.dataInfo.quotationList ? this.dataInfo.quotationList.find(v => v.type === 4) : null

      delOb.deliveryList.forEach(del => {
        if (del.deliveryType !== 'ZT') {
          del.deliveryPartitionList.forEach(delPart => {
            if (delPart.partitionType === 1) {
              // 公里 delPart.quotedPricePartitionList单条 pricePartitionDetail多条
              const firstOb = delPart.quotedPricePartitionList[0]
              delPart.quotedPricePartitionList = firstOb.pricePartitionDetail.map(pr => {
                return {
                  chargeType: firstOb.chargeType,
                  id: firstOb.id,
                  partitionType: firstOb.partitionType,
                  ...pr
                }
              })
            } else {
              // 分区
              delPart.quotedPricePartitionList = delPart.quotedPricePartitionList.map(v => {
                return {
                  ...v,
                  ...v.pricePartitionDetail[0]
                }
              })
            }
            
            const result = this.filterData({goodsSectionQuoteList: delPart.intervalSchemeDetailHeaderList, quotedPriceDetailList: delPart.quotedPricePartitionList})
            console.log(result)
            if (delPart.isLowElimination) result.column.push({ prop: 'minimalPrice', label: 'MINIMAL' })
            delPart.columns = [
              ...result.column,
              { prop: 'currency', label: '币种' },
              { prop: 'aging', label: '派送时效' },
              { prop: 'remark', label: '备注' }
            ]
          })
        }
      })
    },
    filterData(origin = { goodsSectionQuoteList: [], quotedPriceDetailList: []}, onlyprice=true) {
      const column = origin.goodsSectionQuoteList.map((v, i) => {
        return {
          prop: onlyprice ? `price${v.sort}` : `salePrice${v.sort}`,
          label: i + 1 === origin.goodsSectionQuoteList.length && !v.segmentEnd ? `${v.segmentStart} ${v.goodsBillingUnit || v.billingUnit} +` : `${v.segmentStart} ${v.goodsBillingUnit || v.billingUnit}-${v.segmentEnd} ${v.goodsBillingUnit || v.billingUnit}`,
          // contact: 'currency',
          // billingUnit: v.billingUnit
        }
      })


      const tableData = origin.quotedPriceDetailList.map((v, i) => {
        v.agingTypeName = {1: '工作日', 2: '自然日'}[v.agingType]
        v.distance = i + 1 === origin.quotedPriceDetailList.length && !v.segmentEnd ? `${v.segmentStart} ${v.billingUnit || 'KM'} +` : `${v.segmentStart} ${v.billingUnit || 'KM'}-${v.segmentEnd} ${v.billingUnit || 'KM'}`
        v.aging = `${v.agingFrom}-${v.agingTo}${v.agingTypeName}`
        if (origin.currency) v.currency = origin.currency
        return v
      })

      return {column, tableData}
    },
    close() {
      this.$emit('close')
    },
    setName(val) {
      return { HP: '海派', WC: '整柜直送', FP: '空派', KK: '空卡', HK: '海卡', KP: '卡派', KDP: '快递派', WC: '整柜直送', ZT: '自提' }[val]
    },
    setContent(list) {
      console.log(list)
      if (list && list.length) {
        return list.map(v => v.linkName).join(',')
      } else return ''
    }
  }
}
</script>

<style lang="scss" scoped>
  /deep/ .el-dialog {
    margin-bottom: 25px;
    background: #F8F8F8;
    border-radius: 12px;
    border: 1px solid #FFFFFF;
    .el-dialog__body {
      padding-top: 0
    }
  }
  .coast-box {
    margin-top: 10px;
    padding: 5px 20px 15px 20px;
    background: #FFFFFF;
    border-radius: 12px;
  }
  .coast-bar {
    .title {
      position: relative;
      margin-top: 15px;
      padding-left: 10px;
      display: flex;
      justify-content: space-between;
      color: #141414;
      &::before {
        content: '';
        position: absolute;
        top: 2px;
        left: 0;
        display: block;
        width: 4px;
        height: 20px;
        background: #FF4D01;
        border-radius: 1px;
      }
      &-text {
        font-size: 18px;
        font-weight: bold;
        line-height: 25px;
      }
    }
  }
  .coast-header {
    font-size: 22px;
    color: #141414;
    line-height: 33px;
    text-align: center;
    h3 {
      font-weight: bold;
    }
    img {
      position: absolute;
      right: 20px;
      top: 20px;
      cursor: pointer;
      &:hover {
        opacity: .8;
      }
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/placeOrder/components/globalCloudWareQuotation/quotationDetails.vue